<template>
    <main-content>
        <kt-panel>
            <kt-panel-header>
                <kt-panel-header-toolbar>
                    <ul class="nav nav-pills" role="tablist">
                        <li class="nav-item">
                            <a :class="['nav-link', currentTab === 1 ? 'active' : '']" href="#templates"
                               @click="gotoTab(1)">
                                {{ $t('online_contract.templates') }}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a :class="['nav-link', currentTab === 2 ? 'active' : '']" href="#wage_setting"
                               @click="gotoTab(2)">
                                {{ $t('online_contract.wage_setting') }}
                            </a>
                        </li>
                    </ul>
                </kt-panel-header-toolbar>
            </kt-panel-header>
            <kt-panel-body>
                <div class="tab-content">
                    <div :class="['tab-pane', currentTab === 1 ? 'active' : '']" id="#templates">
                        <div style="margin-top: 15px" id="templates" aria-labelledby="templates"
                             data-parent="#templates">
                            <div class="clearfix">
                                <router-link class="kt-nav__link m-2 btn btn-outline-primary float-right"
                                             to="/online-contract/add-template">
                                    {{ $t('online_contract.add_template') }}
                                </router-link>
                            </div>
                            <template-filter :action="filterAction"></template-filter>
                            <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
                        </div>
                    </div>
                </div>
                <div class="tab-content">
                    <div :class="['tab-pane', currentTab === 2 ? 'active' : '']" id="#wage_setting">
                        <div style="margin-top: 15px" id="wage_setting" aria-labelledby="wage_setting"
                             data-parent="#wage_setting">
                            <wage-settings></wage-settings>
                        </div>
                    </div>
                </div>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
import columns from './datatable/TemplateColumns'
import {ApiUrl} from '@/common/api.service'
import {AuthorizationHeader} from '@/common/jwt.service'
import actionsColumn from './components/template/template-actions-column.vue'
import templateFilter from './components/template/template-filter.vue'
import wageSettings from './components/wage-setting.vue'
import mainContent from '@/components/main-content'


export default {

    components: {
        'template-filter': templateFilter,
        wageSettings,
        'main-content': mainContent,
    },
    data() {
        return {
            query: {},
            currentTab: 1
        }
    },
    computed: {
        datatableProps() {
            return {
                id: "deposit_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.path('online-contract/template'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: function (res) {
                                return res.data.data
                            },
                            params: {
                                query: this.query
                            },
                        },
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                pagination: false,
                sortable: true,
                columns: columns,
                actions: actionsColumn
            }
        },
    },
    methods: {
        filterAction(e, query) {
            this.query = query
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
        },
        gotoTab(index) {
            this.currentTab = index;
        }
    }
}
</script>

<style>

</style>